<template>
  <RouterLink :to="{ name: 'CmsEditorV2', query: { customerId, collabInputId } }" class="adventure-create-tile-link ui card">
    <IconEmbedded name="plus_2-5" :size="32" />
    <p class="label">Add Adventure</p>
  </RouterLink>
</template>

<script setup lang="ts">
import IconEmbedded from "@components/ui/IconEmbedded.vue";

defineProps<{ customerId: string; collabInputId: string }>();
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";
.adventure-create-tile-link {
  display: flex;
  min-height: 225px;
  box-shadow: none !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(25% - 20px);
  background: #f0f0f0;
  border: 2px dashed #a6aaac !important;
  &:hover {
    .label {
      text-decoration: underline dotted #a6aaac;
    }
  }
}
.label {
  font-size: 0.9rem;
}

.content {
  display: flex;
  flex-direction: column;
}

@media (max-width: $tablet-max-width) {
  .adventure-create-tile-link {
    width: calc(33.3% - 20px);
  }
}

@media (max-width: $mobile-max-width) {
  .adventure-create-tile-link {
    width: calc(50% - 20px);
  }
}
</style>
